export type AccessUser = { permissions?: string[]; is_super_admin?: boolean } | null | undefined

export function hasPermission(user: AccessUser, permission: string) {
  return user?.is_super_admin === true || user?.permissions?.includes(permission) === true
}

export function resourceAccess(user: AccessUser, subscription: { canRead: boolean; canWrite: boolean }, resource: string) {
  const read = subscription.canRead && hasPermission(user, `${resource}:read`)
  return {
    read,
    create: read && subscription.canWrite && hasPermission(user, `${resource}:create`),
    update: read && subscription.canWrite && hasPermission(user, `${resource}:update`),
    delete: read && subscription.canWrite && hasPermission(user, `${resource}:delete`),
    write: read && subscription.canWrite && hasPermission(user, `${resource}:write`),
    manage: read && subscription.canWrite && hasPermission(user, `${resource}:manage`),
  }
}
